module.exports = __webpack_public_path__ + "img/s3_3.d20cad9b.png";